import React from 'react';
import { Link } from '@inertiajs/react';
import { ChevronRight, Home } from 'lucide-react';
import { cn } from '@/lib/utils';
import { OPS_CONSOLE_HREF } from '@/lib/platformConsoleNav';

export interface BreadcrumbItem {
  label: string;
  href?: string;
  current?: boolean;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
  /** Prepend Ops Console before the Documents home crumb (document pipeline pages). */
  opsConsole?: boolean;
}

export function Breadcrumbs({ items, className, opsConsole = false }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className={cn("flex", className)}>
      <ol className="flex items-center space-x-1 md:space-x-3 flex-wrap">
        {opsConsole && (
          <li className="inline-flex items-center">
            <a
              href={OPS_CONSOLE_HREF}
              className="text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white transition-colors"
            >
              Ops Console
            </a>
            <ChevronRight className="w-3 h-3 text-gray-400 mx-1" aria-hidden />
          </li>
        )}
        {/* Home link */}
        <li className="inline-flex items-center">
          <Link
            href="/documents"
            className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white transition-colors"
          >
            <Home className="w-4 h-4 mr-2.5 text-blue-600" />
            Documents
          </Link>
        </li>
        
        {items.map((item) => (
          <li key={item.label}>
            <div className="flex items-center">
              <ChevronRight className="w-3 h-3 text-gray-400 mx-1" />
              {item.href && !item.current ? (
                <Link
                  href={item.href}
                  className="ml-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ml-2 dark:text-gray-400 dark:hover:text-white"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="ml-1 text-sm font-medium text-gray-500 md:ml-2 dark:text-gray-400">
                  {item.label}
                </span>
              )}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}